<p>{{infoProducts}}</p>
<div id="producst">{{productsXml}}</div>